import React from 'react'
import PropTypes from 'prop-types'
import { Card } from '@/components'
import { clinicalCareStatus } from '@/constants/clinicalCares'

function CardItem({
  header, item, statusList, style,
}) {
  return (
    <Card.Base style={style}>
      <Card.Header>{header}</Card.Header>
      <Card.Body>
        <table className="table table-hover text-small">
          <thead>
            <tr>
              <th>Status</th>
              <th width="100px" className="text-right">Quantidade</th>
            </tr>
          </thead>
          <tbody>
            {statusList.map((status) => (
              <tr key={status}>
                <td>{clinicalCareStatus[status] || status}</td>
                <td className="text-right">{item?.[status] || 0}</td>
              </tr>
            ))}
          </tbody>
          {item?.total !== undefined && (
            <tfoot>
              <tr>
                <th>Total</th>
                <th className="text-right">{item.total}</th>
              </tr>
            </tfoot>
          )}
        </table>
      </Card.Body>
    </Card.Base>
  )
}

CardItem.propTypes = {
  header: PropTypes.node.isRequired,
  item: PropTypes.objectOf(PropTypes.any),
  statusList: PropTypes.arrayOf(PropTypes.string),
  style: PropTypes.objectOf(PropTypes.any),
}

CardItem.defaultProps = {
  item: {},
  statusList: [],
  style: undefined,
}

export default CardItem
